<div class="cardLayout">
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="popup-heading">
        <div class="verticle-center">
          <p class="fs-16 font_regular">Send Wishes</p>
         </div>
         <div class="popup-close">
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="cardBox">
  <ion-row *ngIf="isHideEmployeeInfo">
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="fs-16 font_semibold">{{employeeName}}</div>
        <div class="fs-14 font_regular text_gray mt-5">Email: {{employeeEmail}}</div>
        <div class="fs-14 font_regular text_gray mt-5">Contact: {{employeeContactNo}}</div>
    </ion-col>
  </ion-row>

  <ion-row  class="verticle-center mt-10">
    <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
      <div class="fs-16 font_semibold">Subject:</div>
    </ion-col> 

    <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
      <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
        <input matInput type="text" placeholder="Enter Subject Here...">
      </mat-form-field>
    </ion-col>

    <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
      <button type="button" class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
        <span class="material-icons fs-16 mr-5">send</span>
        Send
      </button>
    </ion-col>
  </ion-row>

  <ion-row  class="verticle-center mt-10">
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div>
        <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="emailContentBody" ></angular-editor>
      </div>
    </ion-col>
  </ion-row>
  </div>
</div>
